module.exports = __webpack_public_path__ + "static/media/colibris blanc small.149dcd8c.png";